import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, args: number): string {
    if (!value) return null;
    let trail = '...';
    if (value.length < args) trail = '';
    return args === -1 ? value : value.substring(0, args) + trail;
  }
}
